
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InnerMenuOldProcessComponent } from './inner-menu-oldprocess.component';
import { OldProcessComponent } from './components/oldprocess/oldprocess.component';
import { RedirectComponent } from '../shared/components/redirect/redirect.component';

export const InnerMenuOldProcessRoutes: Routes = [
    {
        path: '',
        component: InnerMenuOldProcessComponent,
        children: [
            {
                path: '',
                component: RedirectComponent
            },
            {
                path: 'process',
                component: OldProcessComponent
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(InnerMenuOldProcessRoutes)],
    exports: [RouterModule],
    providers: []
})
export class InnerMenuOldProcessRoutingModule { }